const PremissionCategory = {
  Roles: {
    id: 1,
    name: "Roles",
  },
  EmployeeManagement: {
    id: 2,
    name: "Employee Management",
  },
  CustomerManagement: {
    id: 3,
    name: "Customer Management",
  },

  Locations: {
    id: 5,
    name: "Locations",
  },

  Categories: {
    id: 10,
    name: "Categories",
  },

  Masters: {
    id: 15,
    name: "Masters",
  },

  Products: {
    id: 20,
    name: "Products",
  },

  Orders: {
    id: 25,
    name: "Orders & Appointments",
  },

  CustomersVendors: {
    id: 30,
    name: "Customers & Vendors",
  },

  Subscriptions: {
    id: 35,
    name: "Subscriptions",
  },

  FarmersProcurement: {
    id: 40,
    name: "Farmers & Procurement",
  },

  Marketing: {
    id: 45,
    name: "Marketing",
  },

  Reviews: {
    id: 50,
    name: "Reviews",
  },

  Wallet: {
    id: 55,
    name: "Wallet",
  },

  ContentSettings: {
    id: 60,
    name: "Content & Settings",
  },
};

const Permission = {
  Role: {
    List: {
      id: 1,
      name: "Roles List",
      permission_category_id: PremissionCategory.Roles.id,
    },
    Add: {
      id: 2,
      name: "Roles Add",
      permission_category_id: PremissionCategory.Roles.id,
    },
    Edit: {
      id: 3,
      name: "Roles Update",
      permission_category_id: PremissionCategory.Roles.id,
    },
    Delete: {
      id: 4,
      name: "Roles Delete",
      permission_category_id: PremissionCategory.Roles.id,
    },
  },

  Crown: {
    List: {
      id: 248,
      name: "Crown List",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Add: {
      id: 249,
      name: "Crown Create",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Edit: {
      id: 250,
      name: "Crown Edit",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Delete: {
      id: 251,
      name: "Crown Delete",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
  },
  BDMs: {
    List: {
      id: 252,
      name: "BDMs List",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Add: {
      id: 253,
      name: "BDMs Create",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Edit: {
      id: 254,
      name: "BDMs Edit",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Delete: {
      id: 255,
      name: "BDMs Delete",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
  },
  GeneralManager: {
    List: {
      id: 256,
      name: "General Manager List",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Add: {
      id: 257,
      name: "General Manager Create",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Edit: {
      id: 258,
      name: "General Manager Edit",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Delete: {
      id: 259,
      name: "General Manager Delete",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
  },
  Manager: {
    List: {
      id: 260,
      name: "Manager List",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Add: {
      id: 261,
      name: "Manager Create",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Edit: {
      id: 262,
      name: "Manager Edit",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Delete: {
      id: 263,
      name: "Manager Delete",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
  },
  Supervisor: {
    List: {
      id: 264,
      name: "Supervisor List",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Add: {
      id: 265,
      name: "Supervisor Create",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Edit: {
      id: 266,
      name: "Supervisor Edit",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Delete: {
      id: 267,
      name: "Supervisor Delete",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
  },
  Coordinator: {
    List: {
      id: 268,
      name: "Coordinator List",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Add: {
      id: 269,
      name: "Coordinator Create",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Edit: {
      id: 270,
      name: "Coordinator Edit",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
    Delete: {
      id: 271,
      name: "Coordinator Delete",
      permission_category_id: PremissionCategory.EmployeeManagement.id,
    },
  },

  Customer: {
    List: {
      id: 5,
      name: "Customer List",
      permission_category_id: PremissionCategory.CustomerManagement.id,
    },
    Add: {
      id: 6,
      name: "Customer Create",
      permission_category_id: PremissionCategory.CustomerManagement.id,
    },
    Edit: {
      id: 7,
      name: "Customer Edit",
      permission_category_id: PremissionCategory.CustomerManagement.id,
    },
    Delete: {
      id: 8,
      name: "Customer Delete",
      permission_category_id: PremissionCategory.CustomerManagement.id,
    },
  },

  Country: {
    List: {
      id: 9,
      name: "Country List",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Add: {
      id: 10,
      name: "Country Add",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Edit: {
      id: 11,
      name: "Country Edit",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Delete: {
      id: 12,
      name: "Country Delete",
      permission_category_id: PremissionCategory.Locations.id,
    },
  },

  State: {
    List: {
      id: 13,
      name: "State List",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Add: {
      id: 14,
      name: "State Add",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Edit: {
      id: 15,
      name: "State Edit",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Delete: {
      id: 16,
      name: "State Delete",
      permission_category_id: PremissionCategory.Locations.id,
    },
  },

  City: {
    List: {
      id: 17,
      name: "City List",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Add: {
      id: 18,
      name: "City Add",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Edit: {
      id: 19,
      name: "City Edit",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Delete: {
      id: 20,
      name: "City Delete",
      permission_category_id: PremissionCategory.Locations.id,
    },
  },

  Pincode: {
    List: {
      id: 21,
      name: "Pincode List",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Add: {
      id: 22,
      name: "Pincode Add",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Edit: {
      id: 23,
      name: "Pincode Edit",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Delete: {
      id: 24,
      name: "Pincode Delete",
      permission_category_id: PremissionCategory.Locations.id,
    },
  },

  Area: {
    List: {
      id: 205,
      name: "Area List",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Add: {
      id: 206,
      name: "Area Add",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Edit: {
      id: 207,
      name: "Area Edit",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Delete: {
      id: 208,
      name: "Area Delete",
      permission_category_id: PremissionCategory.Locations.id,
    },
  },

  CountryCode: {
    List: {
      id: 181,
      name: "Country Code List",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Add: {
      id: 182,
      name: "Country Code Add",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Edit: {
      id: 183,
      name: "Country Code Edit",
      permission_category_id: PremissionCategory.Locations.id,
    },
    Delete: {
      id: 184,
      name: "Country Code Delete",
      permission_category_id: PremissionCategory.Locations.id,
    },
  },

  StoreCategory: {
    List: {
      id: 25,
      name: "Store Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 26,
      name: "Store Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 27,
      name: "Store Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 28,
      name: "Store Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  StoreSubCategory: {
    List: {
      id: 29,
      name: "Store Sub Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 30,
      name: "Store Sub Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 31,
      name: "Store Sub Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 32,
      name: "Store Sub Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  StoreChildCategory: {
    List: {
      id: 33,
      name: "Store Child Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 34,
      name: "Store Child Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 35,
      name: "Store Child Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 36,
      name: "Store Child Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  ProductCategory: {
    List: {
      id: 37,
      name: "Product Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 38,
      name: "Product Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 39,
      name: "Product Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 40,
      name: "Product Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  ProductSubCategory: {
    List: {
      id: 41,
      name: "Product Sub Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 42,
      name: "Product Sub Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 43,
      name: "Product Sub Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 44,
      name: "Product Sub Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  ProductChildCategory: {
    List: {
      id: 45,
      name: "Product Child Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 46,
      name: "Product Child Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 47,
      name: "Product Child Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 48,
      name: "Product Child Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  FoodCategory: {
    List: {
      id: 49,
      name: "Food Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 50,
      name: "Food Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 51,
      name: "Food Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 52,
      name: "Food Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  FoodSubCategory: {
    List: {
      id: 53,
      name: "Food Sub Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 54,
      name: "Food Sub Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 55,
      name: "Food Sub Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 56,
      name: "Food Sub Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  FoodChildCategory: {
    List: {
      id: 57,
      name: "Food Child Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 58,
      name: "Food Child Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 59,
      name: "Food Child Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 60,
      name: "Food Child Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  RestaurantCategory: {
    List: {
      id: 133,
      name: "Restaurant Category List",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Add: {
      id: 134,
      name: "Restaurant Category Add",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Edit: {
      id: 135,
      name: "Restaurant Category Edit",
      permission_category_id: PremissionCategory.Categories.id,
    },
    Delete: {
      id: 136,
      name: "Restaurant Category Delete",
      permission_category_id: PremissionCategory.Categories.id,
    },
  },

  Brand: {
    List: {
      id: 61,
      name: "Brand List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 62,
      name: "Brand Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 63,
      name: "Brand Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 64,
      name: "Brand Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  Unit: {
    List: {
      id: 81,
      name: "Unit List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 82,
      name: "Unit Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 83,
      name: "Unit Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 84,
      name: "Unit Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  PaymentType: {
    List: {
      id: 77,
      name: "Payment Type List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 78,
      name: "Payment Type Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 79,
      name: "Payment Type Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 80,
      name: "Payment Type Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  CancelReason: {
    List: {
      id: 141,
      name: "Cancel Reason List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 142,
      name: "Cancel Reason Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 143,
      name: "Cancel Reason Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 144,
      name: "Cancel Reason Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  ReturnReason: {
    List: {
      id: 145,
      name: "Return Reason List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 146,
      name: "Return Reason Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 147,
      name: "Return Reason Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 148,
      name: "Return Reason Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  RejectReason: {
    List: {
      id: 185,
      name: "Rejected Reasons List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 186,
      name: "Rejected Reasons Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 187,
      name: "Rejected Reasons Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 188,
      name: "Rejected Reasons Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  Review_Reason: {
    List: {
      id: 217,
      name: "Review Reason List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 218,
      name: "Review Reason Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 219,
      name: "Review Reason Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 220,
      name: "Review Reason Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  ApprovalStatus: {
    List: {
      id: 137,
      name: "Approval Status List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 138,
      name: "Approval Status Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 139,
      name: "Approval Status Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 140,
      name: "Approval Status Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  TimeSlot: {
    List: {
      id: 191,
      name: "Time Slot List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 192,
      name: "Time Slot Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 193,
      name: "Time Slot Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 194,
      name: "Time Slot Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  Crop: {
    List: {
      id: 209,
      name: "Crop List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 210,
      name: "Crop Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 211,
      name: "Crop Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 212,
      name: "Crop Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  RestaurantService: {
    List: {
      id: 121,
      name: "Restaurant Service List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 122,
      name: "Restaurant Service Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 123,
      name: "Restaurant Service Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 124,
      name: "Restaurant Service Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  FoodAddOnCategory: {
    List: {
      id: 125,
      name: "Food Add On Category List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 126,
      name: "Food Add On Category Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 127,
      name: "Food Add On Category Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 128,
      name: "Food Add On Category Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  FoodAddOn: {
    List: {
      id: 129,
      name: "Food Add On List",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Add: {
      id: 130,
      name: "Food Add On Add",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Edit: {
      id: 131,
      name: "Food Add On Edit",
      permission_category_id: PremissionCategory.Masters.id,
    },
    Delete: {
      id: 132,
      name: "Food Add On Delete",
      permission_category_id: PremissionCategory.Masters.id,
    },
  },

  Product: {
    List: {
      id: 85,
      name: "Product List",
      permission_category_id: PremissionCategory.Products.id,
    },
    Add: {
      id: 86,
      name: "Product Add",
      permission_category_id: PremissionCategory.Products.id,
    },
    Edit: {
      id: 87,
      name: "Product Edit",
      permission_category_id: PremissionCategory.Products.id,
    },
    Delete: {
      id: 88,
      name: "Product Delete",
      permission_category_id: PremissionCategory.Products.id,
    },
  },

  OfferedProduct: {
    List: {
      id: 177,
      name: "Offered Product List",
      permission_category_id: PremissionCategory.Products.id,
    },
    Add: {
      id: 178,
      name: "Offered Product Add",
      permission_category_id: PremissionCategory.Products.id,
    },
    Edit: {
      id: 179,
      name: "Offered Product Edit",
      permission_category_id: PremissionCategory.Products.id,
    },
    Delete: {
      id: 180,
      name: "Offered Product Delete",
      permission_category_id: PremissionCategory.Products.id,
    },
  },

  Order: {
    List: {
      id: 101,
      name: "Order List",
      permission_category_id: PremissionCategory.Orders.id,
    },
    Add: {
      id: 102,
      name: "Order Add",
      permission_category_id: PremissionCategory.Orders.id,
    },
    Edit: {
      id: 103,
      name: "Order Edit",
      permission_category_id: PremissionCategory.Orders.id,
    },
    Delete: {
      id: 104,
      name: "Order Delete",
      permission_category_id: PremissionCategory.Orders.id,
    },
  },

  Appointment: {
    List: {
      id: 189,
      name: "Appointment List",
      permission_category_id: PremissionCategory.Orders.id,
    },
    Edit: {
      id: 203,
      name: "Appointment Edit",
      permission_category_id: PremissionCategory.Orders.id,
    },
    Delete: {
      id: 204,
      name: "Appointment Delete",
      permission_category_id: PremissionCategory.Orders.id,
    },
  },

  Vendor: {
    List: {
      id: 69,
      name: "Vendor List",
      permission_category_id: PremissionCategory.CustomersVendors.id,
    },
    Add: {
      id: 70,
      name: "Vendor Add",
      permission_category_id: PremissionCategory.CustomersVendors.id,
    },
    Edit: {
      id: 71,
      name: "Vendor Edit",
      permission_category_id: PremissionCategory.CustomersVendors.id,
    },
    Delete: {
      id: 72,
      name: "Vendor Delete",
      permission_category_id: PremissionCategory.CustomersVendors.id,
    },
  },

  Plan: {
    List: {
      id: 65,
      name: "Plan List",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Add: {
      id: 66,
      name: "Plan Add",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Edit: {
      id: 67,
      name: "Plan Edit",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Delete: {
      id: 68,
      name: "Plan Delete",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
  },

  PlanFeature: {
    List: {
      id: 199,
      name: "Plan Feature List",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Add: {
      id: 200,
      name: "Plan Feature Add",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Edit: {
      id: 201,
      name: "Plan Feature Edit",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Delete: {
      id: 202,
      name: "Plan Feature Delete",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
  },

  Subscription: {
    List: {
      id: 73,
      name: "Subscription List",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Add: {
      id: 74,
      name: "Subscription Add",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Edit: {
      id: 75,
      name: "Subscription Edit",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
    Delete: {
      id: 76,
      name: "Subscription Delete",
      permission_category_id: PremissionCategory.Subscriptions.id,
    },
  },

  Farmer: {
    List: {
      id: 190,
      name: "Farmer List",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Add: {
      id: 225,
      name: "Farmer Add",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Edit: {
      id: 226,
      name: "Farmer Edit",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Delete: {
      id: 227,
      name: "Farmer Delete",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
  },

  Farmer_Detail: {
    List: {
      id: 221,
      name: "Farmer Detail List",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Add: {
      id: 222,
      name: "Farmer Detail Add",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Edit: {
      id: 223,
      name: "Farmer Detail Edit",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Delete: {
      id: 224,
      name: "Farmer Detail Delete",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
  },

  Collection_Center: {
    List: {
      id: 213,
      name: "Collection Center List",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Add: {
      id: 214,
      name: "Collection Center Add",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Edit: {
      id: 215,
      name: "Collection Center Edit",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Delete: {
      id: 216,
      name: "Collection Center Delete",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
  },

  Purchase_Order: {
    List: {
      id: 228,
      name: "Purchase List",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Add: {
      id: 229,
      name: "Purchase Add",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Edit: {
      id: 230,
      name: "Purchase Edit",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Delete: {
      id: 231,
      name: "Purchase Delete",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
  },

  Receiving_Order: {
    List: {
      id: 232,
      name: "Receiving List",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Add: {
      id: 233,
      name: "Receiving Add",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Edit: {
      id: 234,
      name: "Receiving Edit",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Delete: {
      id: 235,
      name: "Receiving Delete",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
  },

  Supplier: {
    List: {
      id: 236,
      name: "Supplier List",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Add: {
      id: 237,
      name: "Supplier Add",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Edit: {
      id: 238,
      name: "Supplier Edit",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
    Delete: {
      id: 239,
      name: "Supplier Delete",
      permission_category_id: PremissionCategory.FarmersProcurement.id,
    },
  },

  Coupon: {
    List: {
      id: 109,
      name: "Coupon List",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Add: {
      id: 110,
      name: "Coupon Add",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Edit: {
      id: 111,
      name: "Coupon Edit",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Delete: {
      id: 112,
      name: "Coupon Delete",
      permission_category_id: PremissionCategory.Marketing.id,
    },
  },

  HomeBanner: {
    List: {
      id: 89,
      name: "Home Banner List",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Add: {
      id: 90,
      name: "Home Banner Add",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Edit: {
      id: 91,
      name: "Home Banner Edit",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Delete: {
      id: 92,
      name: "Home Banner Delete",
      permission_category_id: PremissionCategory.Marketing.id,
    },
  },

  GalleryImage: {
    List: {
      id: 117,
      name: "Gallery Images List",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Add: {
      id: 118,
      name: "Gallery Images Add",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Edit: {
      id: 119,
      name: "Gallery Images Edit",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Delete: {
      id: 120,
      name: "Gallery Images Delete",
      permission_category_id: PremissionCategory.Marketing.id,
    },
  },

  HomeWatchAndShop: {
    List: {
      id: 244,
      name: "Watch And Shop List",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Add: {
      id: 245,
      name: "Watch And Shop Add",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Edit: {
      id: 246,
      name: "Watch And Shop Edit",
      permission_category_id: PremissionCategory.Marketing.id,
    },
    Delete: {
      id: 247,
      name: "Watch And Shop Delete",
      permission_category_id: PremissionCategory.Marketing.id,
    },
  },

  RatingReview: {
    List: {
      id: 93,
      name: "Rating Reviews List",
      permission_category_id: PremissionCategory.Reviews.id,
    },
    Add: {
      id: 94,
      name: "Rating Reviews Add",
      permission_category_id: PremissionCategory.Reviews.id,
    },
    Edit: {
      id: 95,
      name: "Rating Reviews Edit",
      permission_category_id: PremissionCategory.Reviews.id,
    },
    Delete: {
      id: 96,
      name: "Rating Reviews Delete",
      permission_category_id: PremissionCategory.Reviews.id,
    },
  },

  ReviewReply: {
    List: {
      id: 97,
      name: "Reviews Reply List",
      permission_category_id: PremissionCategory.Reviews.id,
    },
    Add: {
      id: 98,
      name: "Reviews Reply Add",
      permission_category_id: PremissionCategory.Reviews.id,
    },
    Edit: {
      id: 99,
      name: "Reviews Reply Edit",
      permission_category_id: PremissionCategory.Reviews.id,
    },
    Delete: {
      id: 100,
      name: "Reviews Reply Delete",
      permission_category_id: PremissionCategory.Reviews.id,
    },
  },

  Wallet: {
    List: {
      id: 113,
      name: "Wallet List",
      permission_category_id: PremissionCategory.Wallet.id,
    },
    Add: {
      id: 114,
      name: "Wallet Add",
      permission_category_id: PremissionCategory.Wallet.id,
    },
    Edit: {
      id: 115,
      name: "Wallet Edit",
      permission_category_id: PremissionCategory.Wallet.id,
    },
    Delete: {
      id: 116,
      name: "Wallet Delete",
      permission_category_id: PremissionCategory.Wallet.id,
    },
  },

  FaqCategory: {
    List: {
      id: 149,
      name: "Faq Category List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 150,
      name: "Faq Category Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 151,
      name: "Faq Category Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 152,
      name: "Faq Category Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  Faq: {
    List: {
      id: 153,
      name: "Faq List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 154,
      name: "Faq Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 155,
      name: "Faq Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 156,
      name: "Faq Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  AboutUs: {
    List: {
      id: 157,
      name: "About Us List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 158,
      name: "About Us Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 159,
      name: "About Us Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 160,
      name: "About Us Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  AboutUsContent: {
    List: {
      id: 240,
      name: "About Us List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 241,
      name: "About Us Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 242,
      name: "About Us Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 243,
      name: "About Us Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  TermsAndCondition: {
    List: {
      id: 161,
      name: "Terms And Condition List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 162,
      name: "Terms And Condition Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 163,
      name: "Terms And Condition Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 164,
      name: "Terms And Condition Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  PrivacyPolicy: {
    List: {
      id: 165,
      name: "Privacy Policy List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 166,
      name: "Privacy Policy Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 167,
      name: "Privacy Policy Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 168,
      name: "Privacy Policy Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  AppSetup: {
    List: {
      id: 169,
      name: "App Setup List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 170,
      name: "App Setup Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 171,
      name: "App Setup Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 172,
      name: "App Setup Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  SocialLink: {
    List: {
      id: 173,
      name: "Social Link List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 174,
      name: "Social Link Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 175,
      name: "Social Link Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 176,
      name: "Social Link Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },

  Help: {
    List: {
      id: 195,
      name: "Help List",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Add: {
      id: 196,
      name: "Help Add",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Edit: {
      id: 197,
      name: "Help Edit",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
    Delete: {
      id: 198,
      name: "Help Delete",
      permission_category_id: PremissionCategory.ContentSettings.id,
    },
  },
};

module.exports = { PremissionCategory, Permission };
